module.exports = __webpack_public_path__ + "img/mon_256.5fb190e8.png";